
const Footer = () => {

  return (
    <>
      <footer style={{ margin: 0, background: "#000000" }} className="footer-distributed footerOverride">
        <div className="footer-left">
          <img
            className="mb-3"
            src="/img/landing/showStars/logoshowstars.png"
            alt="Logo ShowStars"
            width="70%"
            height="70%"
          />

          <p className="footer-company-name mt-4 d-none d-md-block">
            Desarrollado por: Educlick &copy; 2018
          </p>
          <p className="footer-company-name d-none d-md-block">322 243 42 96</p>
        </div>

        <div className="footer-center">
          <div>
            <a
              href="https://g.co/kgs/vBtWyWA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-map-marker m-0"></i>
              <p>
                <span>Av. Esperanza #75-25</span> Modelia, Bogotá
              </p>
            </a>
          </div>

          <div>
            <a
              href="https://api.whatsapp.com/send?phone=573118344120&text=Hola,%20quiero%20conocer%20Show%20Stars&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa fa-phone m-0"></i>
              <p>311 834 41 20</p>
            </a>
          </div>
        </div>

        <div className="footer-right">
          <a
            href="https://www.instagram.com/showstarscol/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram m-0" style={{ fontSize: "25px" }}></i>
            <p>@showstarscol</p>
          </a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
